import { ReactComponent as Twitter } from 'assets/icons/icon-twitter.svg';

export default Twitter;
